// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"bf92bebf","582":"ad22b7da","987":"029eb98f"}[chunkId] + ".chunk.js";
};